import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LookupRequest} from '../../../_model/request/LookupRequest';
import {LookupService} from '../../../_services/lookup.service';
import {map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Lookup} from '../../../_model/Lookup';
import {operations} from '../../../_model/constants';
import {EventService} from '../../../_services/event.service';
import {UtilityService} from '../../../_helpers/utility.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-lookupupdate',
  templateUrl: './lookupupdate.component.html',
  styleUrls: ['./lookupupdate.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    MatRadioModule,
    MatButtonModule
  ]
})
export class LookupUpdateComponent implements OnInit {

  isParentExist = '0';
  lookupForm: FormGroup;
  lookupRequest: LookupRequest = new LookupRequest();
  submitButtonName = 'Kaydet';
  lookupList: any[] = [];
  filteredLookupList: Observable<any[]>;
  operationName: string;
  submitted = false;

  constructor(private lookupService: LookupService,
              private formBuilder: FormBuilder,
              private toastr: ToastrService,
              public dialogRef: MatDialogRef<LookupUpdateComponent>,
              @Inject(MAT_DIALOG_DATA) public data: Lookup,
              private eventService: EventService,
              private utilityService: UtilityService) {
  }

  ngOnInit() {
      this.lookupList = this.lookupService.localListLookups();

      if (this.data.parentLookup) {
          this.isParentExist = '1';
      }
      this.createLookupForm();
      this.filteredLookupList = this.lookupForm.get('parent')
          .valueChanges
          .pipe(
              startWith(''),
              map(value => typeof value === 'string' ? value : value.lookupCode + '-' + value.lookupValue),
              map(lookupCodeAndName => lookupCodeAndName ? this._filter(lookupCodeAndName) : this.lookupList.slice())
          );

      if (Object.keys(this.data).length === 0) {
          this.operationName = operations.CREATE;
      } else {
          this.operationName = operations.UPDATE;
          this.submitButtonName = 'Güncelle';
          this.lookupForm.patchValue({
              parent:  this.data.parentLookup ? this.data.parentLookup : null,
              lookupCode: this.data.lookupCode,
              lookupValue: this.data.lookupValue,
              description: this.data.description
          });
      }
  }

  createOrUpdateLookup() {
    this.submitted = true;
    if (this.lookupForm.invalid) {
        return;
    }
    if (this.operationName === operations.UPDATE) {
        this.update();
    } else {
        this.create();
    }
  }

  update() {
      if (!this.validateForm()) {
        return;
      }
      this.submitButtonName = 'Güncelleniyor...';
      this.lookupForm.disable();
      this.lookupRequest = {
          parentId: (this.isParentExist == '0' || this.lookupForm.get('parent').value == null) ? null :  this.lookupForm.get('parent').value.id ,
          lookupCode: this.lookupForm.get('lookupCode').value,
          lookupValue: this.lookupForm.get('lookupValue').value,
          description: this.lookupForm.get('description').value,
          id: this.data.id
      };

      this.lookupService.updateLookup(this.lookupRequest).subscribe(result => {
          this.lookupService.listLookups().subscribe(allLookupsResponse => {
              localStorage.setItem('lookupList', JSON.stringify(allLookupsResponse.responseData.items));
          }, error2 => {}, () => {
              this.toastr.success('Güncelleme işlemi başarılı', '');
              this.dialogRef.close();
              this.submitButtonName = 'Güncelle';
              this.lookupForm.reset();
              this.lookupForm.enable();
          });
      }, error => {
          this.toastr.error(error.error.msg, 'Hata');
          this.dialogRef.close();
      });
  }

  create() {
      if (!this.validateForm()) {
        return;
      }
      this.submitButtonName = 'Kaydediliyor...';
      this.lookupForm.disable();
      this.lookupRequest.parentId = this.lookupForm.get('parent').value == null ? null : this.lookupForm.get('parent').value.id;
      this.lookupRequest.lookupCode = this.lookupForm.controls.lookupCode.value;
      this.lookupRequest.lookupValue = this.lookupForm.controls.lookupValue.value;
      this.lookupRequest.description = this.lookupForm.controls.description.value;

      this.lookupService.saveLookup(this.lookupRequest).subscribe(saveLookupResult => {
          this.lookupService.listLookups().subscribe(allLookupsResponse => {
              localStorage.setItem('lookupList', JSON.stringify(allLookupsResponse.responseData.items));
          }, error2 => {}, () => {
              this.toastr.success('Kaydedildi', 'Başarılı');
              this.dialogRef.close();
              this.submitButtonName = 'Kaydet';
              this.lookupForm.reset();
              this.lookupForm.enable();
          });
      }, error2 => {
          this.toastr.error(error2.responseData.msg, 'Hata');
          this.dialogRef.close();
      });
  }

  createLookupForm() {
      this.lookupForm = this.formBuilder.group({
          parent: [''],
          lookupCode: ['', [Validators.required]],
          lookupValue: ['', [Validators.required]],
          description: ['', Validators.maxLength(500)]
      });
  }

  displayFn(lookup?: any): any | undefined {
    return lookup ? lookup.lookupCode + '-' + lookup.lookupValue : undefined;
  }

  private _filter(value: any): any[] {
    const filterValue = value.toLowerCase();
    return this.lookupList.filter(lookup => (lookup.lookupCode + '-' + lookup.lookupValue).toLowerCase().indexOf(filterValue) >= 0);
  }

  closeModal() {
    this.dialogRef.close();
  }

  validateForm() {
    if (this.isParentExist === '1' && this.utilityService.requireMatch(this.lookupForm.get('parent')) != null) {
      this.toastr.warning('Ana lookup seçiniz', 'Uyarı');
      return false;
    }
    return true;
  }
}
